import { useCallback } from 'react'
import { useConfirmDialog, ErrorMessage } from 'store/actions/ui.action'
import errorMessages from 'utilities/errorMessages'
export const IMAGE_NOT_FOUND_ERROR = 'image.error.not_found'
export const FILE_NOT_FOUND_ERROR = 'file.error.not_found'
const useUpsertWithImageValidation = () => {
    const { showErrorMessageDialog } = useConfirmDialog()
    const upsertWithImageValidation = useCallback(
        async (processCallback: (...hasParams: any) => any) => {
            try {
                await processCallback()
            } catch (err) {
                const { message } = errorMessages(err)
                if (message === FILE_NOT_FOUND_ERROR)
                    showErrorMessageDialog({
                        message: IMAGE_NOT_FOUND_ERROR,
                    } as ErrorMessage)
                //throw error to stop next operation
                throw err
            }
        },
        [showErrorMessageDialog],
    )
    return { upsertWithImageValidation }
}

export default useUpsertWithImageValidation
